// eslint-disable-next-line @typescript-eslint/naming-convention
export class WindowService {
  static getWindow<T extends Window>(): T {
    return window as unknown as T;
  }
}
